/**
 * Base API
 * API for Base Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FormatConfigEntry { 
    type?: FormatConfigEntry.TypeEnum;
    element?: FormatConfigEntry.ElementEnum;
    path?: string;
    componentId?: string;
    pathPresent?: boolean;
    componentIdPresent?: boolean;
    pathAndComponentIdPresent?: boolean;
}
export namespace FormatConfigEntry {
    export type TypeEnum = 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM';
    export const TypeEnum = {
        BELEG: 'BELEG' as TypeEnum,
        BENUTZER: 'BENUTZER' as TypeEnum,
        BODENBEDECKUNG: 'BODENBEDECKUNG' as TypeEnum,
        ZUSATZANGABEN: 'ZUSATZANGABEN' as TypeEnum,
        CAPITITEL: 'CAPITITEL' as TypeEnum,
        EIGENTUMANTEIL: 'EIGENTUMANTEIL' as TypeEnum,
        HANDELSANGABEN: 'HANDELSANGABEN' as TypeEnum,
        GEBAEUDE: 'GEBAEUDE' as TypeEnum,
        GEBAEUDEEINGANGSADRESSE: 'GEBAEUDEEINGANGSADRESSE' as TypeEnum,
        GRUNDBUCHAMT: 'GRUNDBUCHAMT' as TypeEnum,
        GRUNDBUCHGESCHAEFT: 'GRUNDBUCHGESCHAEFT' as TypeEnum,
        GEOMETERGESCHAEFT: 'GEOMETERGESCHAEFT' as TypeEnum,
        GRUNDBUCHPERSON: 'GRUNDBUCHPERSON' as TypeEnum,
        GRUNDPFANDRECHT: 'GRUNDPFANDRECHT' as TypeEnum,
        AMTLICHEBEWERTUNG: 'AMTLICHE_BEWERTUNG' as TypeEnum,
        GRUNDPFANDRECHTBELASTUNG: 'GRUNDPFANDRECHTBELASTUNG' as TypeEnum,
        GRUNDSTUECK: 'GRUNDSTUECK' as TypeEnum,
        GRUNDSTUECKBESCHREIBUNG: 'GRUNDSTUECKBESCHREIBUNG' as TypeEnum,
        PERSONENADRESSE: 'PERSONENADRESSE' as TypeEnum,
        RECHTEID: 'RECHTEID' as TypeEnum,
        STAMMPERSON: 'STAMMPERSON' as TypeEnum,
        PERSONGB: 'PERSONGB' as TypeEnum,
        STANDARDRECHT: 'STANDARDRECHT' as TypeEnum,
        TIMEPOINT: 'TIMEPOINT' as TypeEnum,
        AVMUTATION: 'AVMUTATION' as TypeEnum,
        AMTNUMMER: 'AMTNUMMER' as TypeEnum,
        RECHTLISTITEM: 'RECHTLISTITEM' as TypeEnum
    };
    export type ElementEnum = 'AMTNUMMER_MIT' | 'AMTNUMMER_OHNE' | 'BELEG_TYP00' | 'BELEG_TYP01' | 'BELEG_TYP02' | 'BENUTZER_TYP00' | 'BENUTZER_TYP01' | 'BODENBEDECKUNG_TYP00' | 'ZUSATZANGABEN_TYP00' | 'CAPITITEL_TYP00' | 'EIGENTUMANTEIL_TYP00' | 'EIGENTUMANTEIL_TYP01' | 'HANDELSANGABEN_TYP00' | 'GEBAEUDE_TYP00' | 'GEBAEUDE_TYP01' | 'GEBAEUDE_TYP02' | 'GEBAEUDE_TYP03' | 'GEBAEUDE_TYP04' | 'GEBAEUDE_TYP05' | 'GEBAEUDE_TYP06' | 'GEBAEUDEEINGANGSADRESSE_TYP00' | 'GRUNDBUCHAMT_TYP00' | 'GRUNDBUCHAMT_TYP01' | 'GRUNDBUCHGESCHAEFT_TYP00' | 'GRUNDBUCHGESCHAEFT_TYP01' | 'GRUNDBUCHGESCHAEFT_TYP02' | 'GEOMETERGESCHAEFT_TYP00' | 'GRUNDBUCHPERSON_TYP00' | 'GRUNDBUCHPERSON_TYP01' | 'GRUNDPFANDRECHT_TYP00' | 'GRUNDPFANDRECHT_TYP01' | 'GRUNDPFANDRECHT_TYP02' | 'AMTLICHE_BEWERTUNG_TYP00' | 'AMTLICHE_BEWERTUNG_TYP01' | 'AMTLICHE_BEWERTUNG_TYP02' | 'AMTLICHE_BEWERTUNG_TYP03' | 'GRUNDPFANDRECHTBELASTUNG_TYP00' | 'GRUNDPFANDRECHTBELASTUNG_TYP01' | 'GRUNDSTUECK_TYP00' | 'GRUNDSTUECK_TYP01' | 'GRUNDSTUECK_TYP02' | 'GRUNDSTUECK_BESCHREIBUNG_TYP00' | 'PERSONENADRESSE_TYP00' | 'PERSONENADRESSE_TYP01' | 'PERSONGB_TYP00' | 'PERSONGB_TYP01' | 'RECHTEID_TYP00' | 'RECHTLISTITEM_DEFAULT' | 'RECHTLISTITEM_RECHTE_ID' | 'STAMMPERSON_TYP00' | 'STAMMPERSON_TYP01' | 'STAMMPERSON_TYP02' | 'STANDARDRECHT_TYP00' | 'STANDARDRECHT_TYP01' | 'STANDARDRECHT_TYP02' | 'STANDARDRECHT_TYP03' | 'AVMUTATION_TYP00' | 'TIMEPOINT_TYP00' | 'TIMEPOINT_TYP01';
    export const ElementEnum = {
        AMTNUMMERMIT: 'AMTNUMMER_MIT' as ElementEnum,
        AMTNUMMEROHNE: 'AMTNUMMER_OHNE' as ElementEnum,
        BELEGTYP00: 'BELEG_TYP00' as ElementEnum,
        BELEGTYP01: 'BELEG_TYP01' as ElementEnum,
        BELEGTYP02: 'BELEG_TYP02' as ElementEnum,
        BENUTZERTYP00: 'BENUTZER_TYP00' as ElementEnum,
        BENUTZERTYP01: 'BENUTZER_TYP01' as ElementEnum,
        BODENBEDECKUNGTYP00: 'BODENBEDECKUNG_TYP00' as ElementEnum,
        ZUSATZANGABENTYP00: 'ZUSATZANGABEN_TYP00' as ElementEnum,
        CAPITITELTYP00: 'CAPITITEL_TYP00' as ElementEnum,
        EIGENTUMANTEILTYP00: 'EIGENTUMANTEIL_TYP00' as ElementEnum,
        EIGENTUMANTEILTYP01: 'EIGENTUMANTEIL_TYP01' as ElementEnum,
        HANDELSANGABENTYP00: 'HANDELSANGABEN_TYP00' as ElementEnum,
        GEBAEUDETYP00: 'GEBAEUDE_TYP00' as ElementEnum,
        GEBAEUDETYP01: 'GEBAEUDE_TYP01' as ElementEnum,
        GEBAEUDETYP02: 'GEBAEUDE_TYP02' as ElementEnum,
        GEBAEUDETYP03: 'GEBAEUDE_TYP03' as ElementEnum,
        GEBAEUDETYP04: 'GEBAEUDE_TYP04' as ElementEnum,
        GEBAEUDETYP05: 'GEBAEUDE_TYP05' as ElementEnum,
        GEBAEUDETYP06: 'GEBAEUDE_TYP06' as ElementEnum,
        GEBAEUDEEINGANGSADRESSETYP00: 'GEBAEUDEEINGANGSADRESSE_TYP00' as ElementEnum,
        GRUNDBUCHAMTTYP00: 'GRUNDBUCHAMT_TYP00' as ElementEnum,
        GRUNDBUCHAMTTYP01: 'GRUNDBUCHAMT_TYP01' as ElementEnum,
        GRUNDBUCHGESCHAEFTTYP00: 'GRUNDBUCHGESCHAEFT_TYP00' as ElementEnum,
        GRUNDBUCHGESCHAEFTTYP01: 'GRUNDBUCHGESCHAEFT_TYP01' as ElementEnum,
        GRUNDBUCHGESCHAEFTTYP02: 'GRUNDBUCHGESCHAEFT_TYP02' as ElementEnum,
        GEOMETERGESCHAEFTTYP00: 'GEOMETERGESCHAEFT_TYP00' as ElementEnum,
        GRUNDBUCHPERSONTYP00: 'GRUNDBUCHPERSON_TYP00' as ElementEnum,
        GRUNDBUCHPERSONTYP01: 'GRUNDBUCHPERSON_TYP01' as ElementEnum,
        GRUNDPFANDRECHTTYP00: 'GRUNDPFANDRECHT_TYP00' as ElementEnum,
        GRUNDPFANDRECHTTYP01: 'GRUNDPFANDRECHT_TYP01' as ElementEnum,
        GRUNDPFANDRECHTTYP02: 'GRUNDPFANDRECHT_TYP02' as ElementEnum,
        AMTLICHEBEWERTUNGTYP00: 'AMTLICHE_BEWERTUNG_TYP00' as ElementEnum,
        AMTLICHEBEWERTUNGTYP01: 'AMTLICHE_BEWERTUNG_TYP01' as ElementEnum,
        AMTLICHEBEWERTUNGTYP02: 'AMTLICHE_BEWERTUNG_TYP02' as ElementEnum,
        AMTLICHEBEWERTUNGTYP03: 'AMTLICHE_BEWERTUNG_TYP03' as ElementEnum,
        GRUNDPFANDRECHTBELASTUNGTYP00: 'GRUNDPFANDRECHTBELASTUNG_TYP00' as ElementEnum,
        GRUNDPFANDRECHTBELASTUNGTYP01: 'GRUNDPFANDRECHTBELASTUNG_TYP01' as ElementEnum,
        GRUNDSTUECKTYP00: 'GRUNDSTUECK_TYP00' as ElementEnum,
        GRUNDSTUECKTYP01: 'GRUNDSTUECK_TYP01' as ElementEnum,
        GRUNDSTUECKTYP02: 'GRUNDSTUECK_TYP02' as ElementEnum,
        GRUNDSTUECKBESCHREIBUNGTYP00: 'GRUNDSTUECK_BESCHREIBUNG_TYP00' as ElementEnum,
        PERSONENADRESSETYP00: 'PERSONENADRESSE_TYP00' as ElementEnum,
        PERSONENADRESSETYP01: 'PERSONENADRESSE_TYP01' as ElementEnum,
        PERSONGBTYP00: 'PERSONGB_TYP00' as ElementEnum,
        PERSONGBTYP01: 'PERSONGB_TYP01' as ElementEnum,
        RECHTEIDTYP00: 'RECHTEID_TYP00' as ElementEnum,
        RECHTLISTITEMDEFAULT: 'RECHTLISTITEM_DEFAULT' as ElementEnum,
        RECHTLISTITEMRECHTEID: 'RECHTLISTITEM_RECHTE_ID' as ElementEnum,
        STAMMPERSONTYP00: 'STAMMPERSON_TYP00' as ElementEnum,
        STAMMPERSONTYP01: 'STAMMPERSON_TYP01' as ElementEnum,
        STAMMPERSONTYP02: 'STAMMPERSON_TYP02' as ElementEnum,
        STANDARDRECHTTYP00: 'STANDARDRECHT_TYP00' as ElementEnum,
        STANDARDRECHTTYP01: 'STANDARDRECHT_TYP01' as ElementEnum,
        STANDARDRECHTTYP02: 'STANDARDRECHT_TYP02' as ElementEnum,
        STANDARDRECHTTYP03: 'STANDARDRECHT_TYP03' as ElementEnum,
        AVMUTATIONTYP00: 'AVMUTATION_TYP00' as ElementEnum,
        TIMEPOINTTYP00: 'TIMEPOINT_TYP00' as ElementEnum,
        TIMEPOINTTYP01: 'TIMEPOINT_TYP01' as ElementEnum
    };
}


